import { render, staticRenderFns } from "./ComplatedTask.vue?vue&type=template&id=91ead170&scoped=true"
import script from "./ComplatedTask.vue?vue&type=script&lang=js"
export * from "./ComplatedTask.vue?vue&type=script&lang=js"
import style0 from "./ComplatedTask.vue?vue&type=style&index=0&id=91ead170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ead170",
  null
  
)

export default component.exports